module.exports = __webpack_public_path__ + "img/midnight tea.a6444dd2.png";